import { render, staticRenderFns } from "./CompanyStatute.vue?vue&type=template&id=67ad7fe3&"
import script from "./CompanyStatute.vue?vue&type=script&lang=ts&"
export * from "./CompanyStatute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports